export default function() {

	$(function() {
		const $navBtn = $('.js-gnav');
		const $navWrapper = $('.js-gnav-wrapper');
		const $navTarget = $('.js-gnav-target');
		const $navClose = $('.js-gnav-close');
		const $navItem = $('.l-nav__home,.l-nav__item');


		$navBtn.on('click', function(){
			$(this).toggleClass('is-active');

			if ($(this).hasClass('is-active')) {
				$('body').css({overflow:'hidden'});
				$navTarget.addClass('is-show');
				$navItem.addClass('is-active');
				$navWrapper.attr({'aria-expanded':'false'});
				$navTarget.attr({'aria-hidden':'true'});
			} else {
				$('body').css({overflow:'auto'});
				$navTarget.removeClass('is-show');
				$navItem.removeClass('is-active');
				$navWrapper.attr({'aria-expanded':'true'});
				$navTarget.attr({'aria-hidden':'false'});
			};
		});

		$navClose.on('click', function(){
			$('body').css({overflow:'auto'});
			$navTarget.removeClass('is-show');
			$navBtn.removeClass('is-active');
			$navItem.removeClass('is-active');
			$navWrapper.attr({'aria-expanded':'true'});
			$navTarget.attr({'aria-hidden':'false'});
		});
	});
}
